import React, { useEffect, useState } from "react";

import {
    View,
    Text,
    Platform,
    TouchableOpacity,
    Image
} from "react-native";
import AppTheme from "../../utils/Theme";
import User from "../../data/user/User";
import { APP_MENU_SCREENS } from "./Menu";

interface MenuCellProps {
    width: number;
    menuScreenId: APP_MENU_SCREENS;
    onSelectedMenuChange: (selectedMenuId: APP_MENU_SCREENS) => void;
    isSelected: boolean;
}

const MenuCell = (props: MenuCellProps) => {
    const { width, menuScreenId, onSelectedMenuChange } = props;

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    let marginBottom: number = 0;
    let iconContainerSize: number = Math.floor((width - appTheme.pixelPerfect(60)) / 5);
    if (iconContainerSize > appTheme.pixelPerfect(54)) {
        iconContainerSize = appTheme.pixelPerfect(54);
    }
    if ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")){
        iconContainerSize = appTheme.pixelPerfect(70);
        marginBottom = appTheme.pixelPerfect(20);
    }
    const iconSize: number = iconContainerSize - appTheme.pixelPerfect(6);
    if (menuScreenId === "EMPTY") {
        return <View style={{ width: iconSize, height: iconSize }} />
    }
    let icon: number = require("../../assets/img/navigation/nav_icon_activite.png");
    if (menuScreenId === "SEQUENCES") {
        icon = require("../../assets/img/navigation/nav_icon_sequences.png");
    } else if (menuScreenId === "ROOM") {
        if (user.profile === "teacher") {
            icon = require("../../assets/img/navigation/nav_icon_salle_profs.png");
        } else {
            icon = require("../../assets/img/navigation/nav_icon_coin_parents_et_animateurs.png");
        }
    } else if (menuScreenId === "SUB") {
        icon = require("../../assets/img/navigation/nav_icon_premium.png");
    } else if (menuScreenId === "ACCOUNT") {
        icon = require("../../assets/img/navigation/nav_icon_mon_compte.png");
    } else if (menuScreenId === "PREMIUM") {
        icon = require("../../assets/img/navigation/nav_icon_premium.png");
    }
    return <TouchableOpacity key={menuScreenId} disabled={Platform.OS === "web" ? false : props.isSelected} onPress={() => onSelectedMenuChange(menuScreenId)} style={{ marginBottom, backgroundColor: props.isSelected ? appTheme.daySkyColor : "#FFFFFF", borderRadius: 14, width: iconContainerSize, height: iconContainerSize, justifyContent: "center", alignItems: "center" }}>
        <Image source={icon} style={{ width: iconSize, height: iconSize }} />
    </TouchableOpacity>
}

export default MenuCell;